import styled from 'styled-components'
import { Grid } from '../../../utils/style'
// import media from '../../../utils/style'
// import { rem } from 'polished'

const Favourite = styled(Grid)`
  position: absolute;
  top: 8px;
  right: 16px;
  z-index: 3;
  margin-top: 0;

  a {
    display: inline-block;
    background-color: transparent;
    padding: 4px 0 0;

    &:hover {
      background-color: transparent;
    }
  }
  svg {
    transition: transform 0.2s ${(props) => props.theme.ease.ease_out_back};
    transform-origin: 50%;
  }
  path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
    transform-origin: 50%;
  }
  path:last-child {
    fill: #c3c3c4;
  }
  path:first-child {
    transform: scale(1.1) translateZ(0);
    fill: #f5f5f5;
  }
  &:hover path:last-child {
    fill: #c3c3c4;
  }
  & .favourite svg {
    transform: scale(1.16) translateZ(0);
    path {
      fill: ${(props) => props.theme.colors.blue};
    }
  }
  &:hover .favourite svg {
    transform: scale(1.15) translateZ(0);
    path {
      fill: ${(props) => props.theme.colors.blue_dark};
    }
  }
`

Favourite.displayName = 'Favourite'

export { Favourite }
